import { ReportConfig } from "../definitions";

const policyExportAll: ReportConfig = {
  id: "policyExportAll",
  name: "Policy Export All",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "filter",
      label: "Filter",
      dataType: "select",
      options: [
        { key: "Paid", value: "paid" },
        { key: "All", value: "all" },
      ],
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string" },
            { name: "First Name", type: "string" },
            { name: "Last Name", type: "string" },
            { name: "Policy #", type: "string" },
            { name: "GSI", type: "string" },
            { name: "Policy Date", type: "date" },
            { name: "Paid/Closed", type: "date" },
            { name: "Annual Premium", type: "currency" },
            { name: "Base Premium", type: "currency" },
            { name: "Modal Premium", type: "currency" },
            { name: "Status", type: "string" },
            { name: "Mode", type: "string" },
            { name: "Broker", type: "string" },
            { name: "Agent Commission", type: "percent" },
            { name: "Affiliate", type: "string" },
            { name: "Affiliate Name", type: "string" },
            { name: "Occ Class", type: "string" },
            { name: "Occupation", type: "string" },
            { name: "Branch", type: "string" },
          ],
          dataSource: {
            sql: `
SELECT
    cr.[Type] AS [Carrier],
    a.[FirstName],
    a.[LastName],
    a.PolicyNumber,
    CASE
        WHEN gsi.[GSIGroupId] IS NOT NULL THEN 'Yes'
        ELSE 'No'
    END AS [HasGSI],
    -- gsi more info
    -- gsi.[GSIGroupId],
    -- g.[GroupName] AS [GSIGroupName],
    -- /gsi
    -- ISNULL(ai.[ProposalNumber], a.ProposalID) as [ProposalNumber],
    a.[PolicyDate],
    a.PaidOrClosedDate as [Placed],
    ap.AnnualPremium as [AnnuPrem],
    ap.AnnualizedPremium as [BasePrem],
    ap.ModalPremium,
    ast.Description AS [Status],
    CASE WHEN ap.mode = 'A' THEN 'Annual'
        WHEN ap.mode = 'Q' THEN 'Quarterly'
        WHEN ap.mode = 'SA' THEN 'Semi-Annual'
        WHEN ap.mode = 'M' THEN 'Monthly'
        WHEN ap.mode = '1' THEN 'One Pay'
    END AS [Mode],
    b.FirstName + ' ' + b.lastname AS [Broker],
    ac.CommissionPercent,
    CASE
        WHEN ac.[AffiliateID] IS NOT NULL THEN 'Yes'
        ELSE 'No'
    END AS [Affiliate],
    af.[Name],
    pd.[OccupationClass],
    pd.[Occupation],
    bra.[Type] as [Branch]

FROM awu.Application a
    INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.id
    INNER JOIN dbo.BranchType bra on a.BranchTypeID = bra.ID
    LEFT JOIN [awu].[ApplicationBroker] [ac] on a.ID = ac.ApplicationID
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    LEFT JOIN dbo.Broker b on ac.Brokerid = b.ID
    LEFT JOIN dbo.Carriertype cr on a.CarrierID = cr.ID
    LEFT JOIN dbo.Affiliate af on ac.AffiliateID = af.id
    LEFT JOIN awu.ApplicationGroupPolicy gp ON a.id=gp.ApplicationID
    LEFT JOIN [dbo].[ApplicationGSIGroupDetails] AS gsi ON gsi.[ApplicationId] = a.[ID]
    LEFT JOIN [dbo].[GSIGroupDetails] AS g ON g.[ID] = gsi.[GSIGroupId] AND g.[IsDeleted] = 0
    LEFT JOIN [awu].[ApplicationProductDetails] pd ON pd.[ApplicationID] = a.[ID]
    LEFT JOIN [awu].[ApplicationAdditionalInfo] ai ON ai.ApplicationID = a.ID

WHERE
    (a.[IsDeleted] IS NULL OR a.[IsDeleted] = 0)
    AND ((@filter = 'all'
        AND a.CreatedDate BETWEEN @startDate AND @endDate
    )
    OR (@filter = 'paid'
        AND a.PaidOrClosedDate BETWEEN @startDate AND @endDate
        AND st.[ApplicationStatusCode] in ('2', '3', 'P')
        AND st.[ScenarioTypeCode] = 'F'
        --AND ai.[ProposalNumber] <> 222 -- "that don't count toward new business"
    ))
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

ORDER BY [Carrier], a.PolicyNumber, ac.CommissionLevel
`,
            returnType: "table",
          },
          options: { zebraFieldIndex: [3] },
        },
      ],
    },
  ],
};

export default policyExportAll;
